import { OTP_DELIVERY_CHANNELS } from '../../../../../services/exports/Constants';

export default {
  form: {
    phone_number: {
      label: 'Phone number',
      placeholder: 'Enter phone number',
    },
    email: {
      label: 'Email address',
      placeholder: 'Enter email address',
    },
  },
  channel_chooser: {
    title: 'Send code via',
    [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
      label: 'WhatsApp',
      subtitle: 'Free, fastest delivery',
    },
    [OTP_DELIVERY_CHANNELS.SMS]: {
      label: 'SMS',
      subtitle: 'Standard text message',
    },
    [OTP_DELIVERY_CHANNELS.EMAIL]: {
      label: 'Email',
      subtitle: 'Code straight to your inbox',
    },
  },
  otp: {
    title: 'Enter verification code',
    send_code: 'Send code',
    sent_via: {
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Sent via <strong>WhatsApp</strong> to <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.SMS]: 'Sent via <strong>SMS</strong> to <strong>{{phone}}</strong>',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Sent via <strong>email</strong> to <strong>{{phone}}</strong>',
    },
    sent_to: 'Sent to',
    resend: {
      title: "Didn't receive the code?",
      countdown: 'Resend in',
      options: {
        [OTP_DELIVERY_CHANNELS.EMAIL]: {
          title: "Didn't receive the code via email?",
          button: 'Resend via email',
        },
        [OTP_DELIVERY_CHANNELS.SMS]: {
          title: "Didn't receive the code?",
          button: 'Resend via SMS',
        },
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: {
          title: "Didn't receive the code?",
          button: 'Resend via WhatsApp',
        },
      },
      switch: {
        [OTP_DELIVERY_CHANNELS.SMS]: 'Send via SMS instead',
        [OTP_DELIVERY_CHANNELS.WHATSAPP]: 'Send via WhatsApp instead',
      },
    },
    text: {
      [OTP_DELIVERY_CHANNELS.SMS]:
        'A message with a verification code has been sent to your phone. Enter the code to continue.',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Please enter the code sent to this address: <br/> <strong>{{address}}</strong>',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]:
        'A WhatsApp message with a verification code has been sent to your phone. Enter the code to continue.',
    },
    tip: {
      [OTP_DELIVERY_CHANNELS.SMS]: '',
      [OTP_DELIVERY_CHANNELS.EMAIL]: 'Tip: Check your inbox and your spam folder.',
      [OTP_DELIVERY_CHANNELS.WHATSAPP]: '',
    },
  },
  sender_note: {
    disclaimer: 'Heads up — the code is sent from <strong>{{sender}}</strong>, our technology partner.',
    business_account: 'Business account',
    message: '<strong>123456</strong> is your verification code. For your security, do not share this code.',
  },
  error_messages: {
    frequent_requests:
      'Please check your messages. We have already sent the code to the given number. If not, please check the phone number or try again in 10 minutes.',
    frequent_requests_email:
      'Please check your inbox and your spam folder. We have already sent the code to that address. If it has not arrived, try again in 10 minutes.',
    invalid_number: 'Invalid number. Please try again.',
    invalid_email: 'We could not send the code to that email address. Please check it and try again.',
    email_not_on_file:
      'This phone number already has an account without an email address. Please contact {{support_email}} to add one — until then we can’t send codes for this number by email.',
    turnstile_required: 'Please complete the verification before requesting a new code.',
    generic_error: 'Oops, something went wrong. Please refresh the page and try again.',
    change_phone_number_unsuccessful: 'Failed to change phone number. Please try again.',
  },
  toasts: {
    code_sent: 'Code sent',
  },
};
